import { createRoot } from 'react-dom/client';
import { ErrorPage } from '../pages/ErrorPage';

createRoot(document.getElementById('root')!).render(<ErrorPage {...window.__PAGE_PROPS__} />);
